// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frame-wrapper iframe[data-v-206c3d4b]{height:400px;width:100%}", "",{"version":3,"sources":["webpack://./resources/js/Components/CanvasElement/CanvasElementPreview.vue"],"names":[],"mappings":"AAAA,uCAAiC,YAAA,CAAX,UAGtB","sourcesContent":[".frame-wrapper iframe{width:100%;height:400px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
